/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

// Explanation of the regex pattern:
// ^
// Start of the string
// (\+?64|0)
// Matches either the country code with an optional plus sign (+64) or just the leading zero (0)
// [2-9]
// Matches a digit from 2 to 9, as the first digit of the local number
// \d{7,9}
// Matches 7 to 9 digits for the remaining local number
// $
// End of the string
// This regex allows for both landline and mobile phone numbers in New Zealand.
export const nzPhoneNumberRegex = /^(\+?64|0)([2-9]\d{7,}|0800\d{4,})$/;

/**
 * Checks if a phone number is invalid.
 *
 * @param {string | undefined} phoneNumber - The phone number to check.
 * @returns {string | undefined} - The error message if the phone number is invalid, otherwise undefined.
 */
export const isInvalidPhoneNumber = (phoneNumber: string | undefined) => {
  // Check if the phone number is empty
  if (!phoneNumber?.length) {
    return "Phone number is required";
  } else if (phoneNumber && !nzPhoneNumberRegex.test(phoneNumber)) {
    // Check if the phone number is valid according to the regex
    return "Please enter a valid phone number";
  } else {
    // Phone number is valid
    return undefined;
  }
};
